var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('navbar'),_vm._v(" "),_c('main-navigation'),_vm._v(" "),_c('notification'),_vm._v(" "),_c('v-main',[_c('maintenance-mode-alert'),_vm._v(" "),_c('system-messages'),_vm._v(" "),_c('nuxt')],1),_vm._v(" "),_c('page-footer'),_vm._v(" "),_c('scroll-to-top-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }